'use client';

import Link from 'next/link';
import { useStoredValue } from '@/lib/use-stored-value';

export default function CookieConsent() {
  const [consent, setConsent] = useStoredValue('cookie-consent', '', 'accepted');

  const accept = () => {
    setConsent('accepted');
  };

  if (consent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-stone p-4 shadow-lg">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
        <p className="text-sm text-text-body text-center sm:text-left">
          We use essential cookies to keep you signed in and make the site work. No tracking or advertising cookies.{' '}
          <Link href="/privacy#cookies" className="underline text-forest hover:text-forest-light">
            Learn more
          </Link>
        </p>
        <button
          onClick={accept}
          className="shrink-0 bg-forest text-white px-5 py-2 rounded-sm text-sm font-medium hover:bg-forest-light transition-colors"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
